import styled from 'styled-components'

const Container = styled.div`
  width: 1140px;
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  @media screen and (min-width: 320) and (max-width: 1140px) {
    width: 100%;
  }
`

export default Container
